import regionsService from './regionsService'

export default regionsService



// WEBPACK FOOTER //
// ../src/services/regionsService/index.js